/**
 * 顾客信息
 */

import fetch from '../utils/fetch'
import conf from '../conf/base.conf'

export default {}
